'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

var _combineStyles = require('../internal/combine-styles');

var _combineStyles2 = _interopRequireDefault(_combineStyles);

var _fade = require('../internal/fade');

var _fade2 = _interopRequireDefault(_fade);

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var knob = function knob() {
  var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _colors2.default.theme;
  var active = arguments[1];
  var overrideStyle = arguments[2];

  var style = _styles2.default.knob;
  var activeStyle = _styles2.default.knobActive;

  activeStyle = (0, _combineStyles2.default)(activeStyle, { backgroundColor: color });

  if (active) {
    style = (0, _combineStyles2.default)(style, activeStyle);
  }

  return (0, _combineStyles2.default)(style, overrideStyle);
};

var track = function track() {
  var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _colors2.default.theme;
  var active = arguments[1];
  var overrideStyle = arguments[2];

  var style = _styles2.default.track;
  var activeStyle = _styles2.default.trackActive;

  activeStyle = (0, _combineStyles2.default)(activeStyle, { backgroundColor: (0, _fade2.default)(color, 0.5) });

  if (active) {
    style = (0, _combineStyles2.default)(style, activeStyle);
  }

  return (0, _combineStyles2.default)(style, overrideStyle);
};

var label = function label(overrideStyle) {
  return (0, _combineStyles2.default)(_styles2.default.label, overrideStyle);
};

exports.default = {
  knob: knob,
  track: track,
  label: label
};
module.exports = exports.default;